import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  dialog: {
    '& .MuiDialog-paper': {
      borderRadius: '8px',
      minWidth: '580px',
      maxWidth: '650px',
    },
  },
  dialogTitle: {
    padding: '20px 24px 8px 24px',
    textAlign: 'center',
    '& h2': {
      fontSize: '20px',
      fontWeight: 600,
    },
  },
  subtitle: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#000',
    marginTop: '4px',
    textAlign: 'center',
  },
  dialogContent: {
    padding: '16px 24px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'center',
  },
  statusTable: {
    width: '500px',
    minWidth: '500px',
    margin: '0 auto',
    border: '1px solid #E0E0E0',
    borderCollapse: 'collapse',
    '& .MuiTableCell-root': {
      borderTop: '1px solid #E0E0E0',
      borderBottom: '1px solid #E0E0E0',
      borderLeft: 'none',
      borderRight: 'none',
      padding: '10px 16px',
      verticalAlign: 'middle',
    },
    '& .MuiTableCell-root:first-child': {
      width: '60%',
    },
    '& .MuiTableCell-root:last-child': {
      width: '40%',
      textAlign: 'right',
    },
    '& .MuiTableRow:first-child .MuiTableCell-root': {
      borderTop: '1px solid #E0E0E0',
    },
    '& .MuiTableRow:last-child .MuiTableCell-root': {
      borderBottom: '1px solid #E0E0E0',
    },
  },
  tableHeader: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#000',
    backgroundColor: '#F5F5F5',
  },
  statusChip: {
    fontWeight: 500,
    color: 'white',
    width: '120px',
    minWidth: '120px',
    maxWidth: '120px',
    textAlign: 'center',
    height: '32px',
    borderRadius: '4px',
    border: 'none',
    fontSize: '14px',
    '& .MuiChip-label': {
      padding: '0 16px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  select: {
    width: '120px',
    minWidth: '120px',
    maxWidth: '120px',
    '& .MuiOutlinedInput-root': {
      height: '40px',
    },
    '& .MuiSelect-select': {
      paddingRight: '32px',
      paddingLeft: '14px',
    },
  },
  selectWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
  },
  saveButton: {
    backgroundColor: '#ec6535',
    color: '#fff',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '8px 40px',
    minWidth: '120px',
    height: '40px',
    fontSize: '14px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: '#000000',
      color: '#fff',
    },
    '&:hover:disabled': {
      backgroundColor: '#ec6535',
      color: '#fff',
    },
    '&:disabled': {
      backgroundColor: '#ec6535',
      color: '#fff',
      opacity: 0.5,
      cursor: 'not-allowed',
    },
  },
  closeButton: {
    backgroundColor: '#ffffff',
    color: '#000',
    textTransform: 'none',
    borderRadius: '20px',
    padding: '8px 40px',
    minWidth: '120px',
    height: '40px',
    fontSize: '14px',
    fontWeight: 500,
    border: '1px solid #E0E0E0',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      color: '#000',
    },
  },
}));


